/* docs/API.md → Enums. The order of TaskStatus is also the order of the Kanban columns. */
export enum TaskStatus {
    Todo       = 'todo',
    InProgress = 'in_progress',
    Review     = 'review',
    Done       = 'done',
}

export const TASK_STATUS_ORDER: TaskStatus[] = [
    TaskStatus.Todo,
    TaskStatus.InProgress,
    TaskStatus.Review,
    TaskStatus.Done,
]

export enum TaskPriority {
    Low    = 'low',
    Normal = 'normal',
    High   = 'high',
    Urgent = 'urgent',
}

export const TASK_PRIORITY_ORDER: TaskPriority[] = [
    TaskPriority.Low,
    TaskPriority.Normal,
    TaskPriority.High,
    TaskPriority.Urgent,
]

/** GET /tasks/mine?scope= */
export enum TaskScope {
    Open = 'open',
    All  = 'all',
}

/*
 * The limits docs/API.md states for a task, checked in the forms so a wrong value comes
 * back under the field instead of as a 400.
 */
export const TaskLimits = {
    Title:       200,
    Description: 20_000,
    Estimate:    10_000,
    Comment:     10_000,
    /** 25 MB — an attachment over it is refused with code 19. */
    FileBytes:   25 * 1024 * 1024,
} as const
